<template>
  <BoxAvatarTypeInboxBadge :box="box">
    <v-avatar :size="avatarSize" tile>
      <DeepIcon :height="iconHeight" name="box" :width="iconWidth" />
    </v-avatar>
  </BoxAvatarTypeInboxBadge>
</template>

<script setup lang="ts">
import { DeepIcon } from '@deepcloud/deep-ui-lib'
import BoxAvatarTypeInboxBadge from '@/components/box/BoxAvatarTypeInboxBadge.vue'
import type { BoxEntry } from '@deepcloud/api-deep-box'

defineProps({
  box: {
    type: Object as PropType<BoxEntry>,
    default: undefined,
  },
  avatarSize: {
    type: Number,
    default: 24,
  },
  iconHeight: {
    type: Number,
    default: 24,
  },
  iconWidth: {
    type: Number,
    default: 24,
  },
})
</script>
